import {
  MenuItem,
  Paper,
  Select,
  SelectChangeEvent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { FC, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useWindowSize } from 'react-use';
import { css } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';

import Container from 'quarks/Container';
import type { BasicProps } from 'quarks/interpolations/basic';

import type { IComponentTableRecord } from 'graphql/types';

export interface TableComponentProps extends BasicProps, IComponentTableRecord {
  table: IComponentTableRecord['table'];
}

const TableComponent: FC<TableComponentProps> = ({ table }: TableComponentProps) => {
  const { width: windowWidth } = useWindowSize();
  const [tableColumns, setTableColumns] = useState<string[]>([]);
  const [columns, setColumns] = useState<string[]>([]);
  const [data, setData] = useState<string[]>([]);
  const [selectedColumn, setSelectedColumn] = useState<string>('');

  useEffect(() => {
    if (table && table.data && table.data.length > 0) {
      const columnKeys = Object.keys(table.data[0]);
      setColumns(columnKeys.slice(0, columnKeys.length));
      setTableColumns(columnKeys.slice(1));
      setSelectedColumn(columnKeys[1]);
      setData(table.data);
    }
  }, [setData, setColumns, table, setTableColumns]);

  const handleColumnChange = (event: SelectChangeEvent<string>) => {
    setSelectedColumn(event.target.value);
  };

  if (windowWidth < 1000) {
    return (
      <div>
        <Container marginBottom={40}>
          <TableContainer component={Paper}>
            <Table sx={{ maxWidth: '100%' }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    width="50%"
                    css={css`
                      backgroundcolor: '#E6E6E6';
                    `}
                  >
                    {columns && columns[0]}
                  </TableCell>
                  <TableCell
                    width="50%"
                    css={css`
                      backgroundcolor: '#E6E6E6';
                    `}
                  >
                    <Select
                      labelId="column-select-label"
                      id="column-select"
                      value={selectedColumn}
                      onChange={handleColumnChange}
                    >
                      {tableColumns &&
                        tableColumns.map(column => (
                          <MenuItem key={column} value={column}>
                            {column}
                          </MenuItem>
                        ))}
                    </Select>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.length > 0 &&
                  data.map((row: any) => (
                    <TableRow key={uuidv4()}>
                      <TableCell
                        css={css`
                          verticalalign: 'top';
                        `}
                      >
                        <div>
                          <ReactMarkdown>
                            {row && row[columns[0]].toString().substring(0, 6) === 'color:'
                              ? row[columns[0]].toString().substring(8)
                              : row[columns[0]].toString()}
                          </ReactMarkdown>
                        </div>
                      </TableCell>
                      {/* TODO: fix this it's so gross */}
                      <TableCell
                        style={(() => {
                          if (row[selectedColumn]) {
                            switch (row[selectedColumn].toString().substring(6, 7)) {
                              case 'g':
                                return { backgroundColor: '#ACE09A', verticalAlign: 'top' };
                              case 'r':
                                return { backgroundColor: '#F79999', verticalAlign: 'top' };
                              case 'y':
                                return { backgroundColor: '#F6EB86', verticalAlign: 'top' };
                              default:
                                return { backgroundColor: '#fff', verticalAlign: 'top' };
                            }
                          }
                        })()}
                      >
                        <div>
                          <ReactMarkdown
                            css={css`
                              a {
                                text-decocration: underline;
                              }
                              code {
                                display: inline-block;
                                word-break: break-word;
                              }
                            `}
                          >
                            {row[selectedColumn].toString().substring(0, 6) === 'color:'
                              ? row[selectedColumn].toString().substring(8)
                              : row[selectedColumn].toString()}
                          </ReactMarkdown>
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </div>
    );
  } else {
    let desktopColumns: string[] = [''];
    if (table) {
      desktopColumns = Object.keys(table.data[0]);
    }

    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              {desktopColumns &&
                desktopColumns.map(column => (
                  <TableCell
                    key={column}
                    css={css`
                      backgroundcolor: '#E6E6E6';
                    `}
                    width={100 / desktopColumns.length + '%'}
                  >
                    {column}
                  </TableCell>
                ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data &&
              data.length > 0 &&
              data.map((row: any) => (
                <TableRow key={uuidv4()}>
                  {desktopColumns.map(column => (
                    <TableCell
                      width={100 / desktopColumns.length}
                      key={uuidv4()}
                      style={(() => {
                        switch (row[column].toString().substring(6, 7)) {
                          case 'g':
                            return { backgroundColor: '#ACE09A', verticalAlign: 'top' };
                          case 'r':
                            return { backgroundColor: '#F79999', verticalAlign: 'top' };
                          case 'y':
                            return { backgroundColor: '#F6EB86', verticalAlign: 'top' };
                          default:
                            return { backgroundColor: '#fff', verticalAlign: 'top' };
                        }
                      })()}
                    >
                      <div>
                        <ReactMarkdown
                          css={css`
                            a {
                              text-decoration: underline !important;
                            }
                            code {
                              display: inline-block;
                              word-break: break-word;
                            }
                          `}
                        >
                          {row[column].toString().substring(0, 6) === 'color:'
                            ? row[column].toString().substring(8)
                            : row[column].toString()}
                        </ReactMarkdown>
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
};

export default TableComponent;
